/**
 * Mock API for Authentication
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let nextId = 1;
export const mockAuthApi = {
    getCsrfToken: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve('mock-csrf-token'), 300));
    }),
    getAuthToken: (username, password) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({ token: 'mock-auth-token' }), 300));
    }),
    login: (username, password, csrfToken) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({ token: 'mock-auth-token' }), 300));
    }),
    register: (data) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(Object.assign({ id: nextId++ }, data)), 300));
    }),
    changePassword: (oldPassword, newPassword1, newPassword2) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve({ success: true }), 300));
    }),
    logout: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => setTimeout(() => resolve(), 300));
    }),
};
